import React from 'react'
import {useDispatch, useSelector} from "react-redux";
import {transitionToPost} from '../../modules/Transition/actions'

const NewPostButton = (props) => {
    const dispatch = useDispatch();
    const userState = useSelector(state => state.user);
    const isAgreed = userState.isAgreed;

    return (
        <button className="p-icon p-icon__plus"
                onClick={() => {
                    if (isAgreed) {
                        dispatch(transitionToPost())
                    } else {
                        props.handleOpen()
                    }
                }}/>
    )
};

export default NewPostButton
